import { toast } from "react-toastify"

import { FRONT_GENERAL_CONFIG } from "../config/general.config"

export class ToastrHelper {
    /**
     * Show success message
     */
    static success(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
    ) {
        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "success",
            },
        )
    }

    /**
     * Show warning message
     */
    static warning(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
    ) {
        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "warning",
            },
        )
    }

    /**
     * Show error message
     */
    static error(
        msg: string,
        autoClose = FRONT_GENERAL_CONFIG.defaultToastrTimeout,
        withHtml = true,
    ) {
        toast(
            withHtml ? (
                <div
                    className="custom-toastr"
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
            ) : (
                msg
            ),
            {
                autoClose,
                type: "error",
            },
        )
    }
}
